import React from "react";
import "../css/DataDisplayOtrasFormas.css";
const DataDisplayOtrasFormas = ({ data }) => {
  if (!data || data.length === 0) return null;

  return (
    <section className="otras-formas-container bluebg padding">
      <div className="layout9 ">
        <div className="otras-formas-header">
          <h2>
            Descubre otras formas de ingresar <b>a la UTPL y sus beneficios</b>
          </h2>
          <br></br>
        </div>

        <div className="otras-formas-grid">
          {data.map((item, index) => {
            if (!item) return null;

            return (
              <div className="otras-formas-card" key={index}>
                {item.field_image && (
                  <img
                    className="otras-formas-icon"
                    src={`https://tec.utpl.edu.ec/${item.field_image}`}
                    alt={item.field_titulo || "icono"}
                  />
                )}

                {item.field_titulo && (
                  <h3 className="otras-formas-title">{item.field_titulo}</h3>
                )}

                {item.field_contenido && (
                  <div
                    className="otras-formas-content"
                    dangerouslySetInnerHTML={{
                      __html: item.field_contenido,
                    }}
                  />
                )}

                {/* Enlace como bloque adicional */}
                {item.field_nombre_enlace && (
                  <div className="wrapper-otras-formas-link">
                    <a
                      href={item.field_enlace_contenido}
                      target="_blank"
                      className="otras-formas-link"
                      rel="noopener noreferrer" 
                    >
                      {item.field_nombre_enlace} 
                    </a>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>{" "}
    </section>
  );
};

export default DataDisplayOtrasFormas;
